module.exports = __webpack_public_path__ + "static/teddybike4-62510c6d3a1965edb2bcb81974ba426c.png";